module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"distance":"at {distance} km","phoneNumber":"Phone number:"},"fr":{"distance":"à {distance} km","phoneNumber":"Téléphone :"},"de":{"distance":"{distance} km entfernt","phoneNumber":"Telefonnummer:"}}')
  delete Component.options._Ctor
}
